<template>
  <div class="card card--small">
    <div v-if="isManufacturerRangeValid">
      <VehicleInfoComponent
        v-if="showVehicleInfo"
        :isCompact="showVehicleImage"/>
      <VehicleImageComponent
        v-if="showVehicleImage"
        :showCaption="showVehicleImage"/>
    </div>
    <div v-else class="card__loader">
      <LoaderComponent/>
    </div>
    <VehicleScoringComponent
        v-show="showVehicleScoring"
        :vehicleScoreValue="vehicleScoreValue"
        :vehicleScoreText="vehicleScoreText"
        :vehicleAPRValue="vehicleAPRValue"
        :vehicleAPRText="vehicleAPRText" />
    <VehicleSpecsComponent
        v-show="showVehicleSpecs"
        :showDoorSpecs="showDoorSpecs"
        :showColourSpecs="showColourSpecs" />
  </div>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import {
  namespace
} from 'vuex-class';

import VehicleImageComponent from './VehicleImageComponent.vue';
import VehicleInfoComponent from './VehicleInfoComponent.vue';
import VehicleScoringComponent from './VehicleScoringComponent.vue';
import LoaderComponent from '../ui/LoaderComponent.vue';
import VehicleSpecsComponent from './VehicleSpecsComponent.vue';

const VehicleModule = namespace('vehicleModule');

@Component({
  components: {
  VehicleImageComponent,
  VehicleInfoComponent,
  VehicleScoringComponent,
  LoaderComponent,
  VehicleSpecsComponent
  }
  })
export default class VehicleCardComponent extends Vue {
  @VehicleModule.Getter public currentRange;

  @Prop({ default: false })
  public showVehicleInfo!: boolean;

  @Prop({ default: false })
  public showVehicleImage!: boolean;

  @Prop({ default: false })
  public showVehicleScoring!: boolean;

  @Prop({ default: false })
  public showVehicleSpecs!: boolean;

  @Prop({ default: '8.9' })
  public vehicleScoreValue!: string;

  @Prop({ default: 'Great' })
  public vehicleScoreText!: string;

  @Prop({ default: '4.9' })
  public vehicleAPRValue!: string;

  @Prop({ default: '% APR Available*' })
  public vehicleAPRText!: string;

  @Prop({ default: false })
  public showDoorSpecs!: boolean;

  @Prop({ default: false })
  public showColourSpecs!: boolean;

  public get isManufacturerRangeValid() {
    return this.currentRange !== null && this.currentRange.manufacturerName !== null && this.currentRange.rangeName !== null;
  }
}
</script>
